import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Button from "@atoms/Button";
import Icon from "@atoms/Icon";
import Link from "@atoms/Link";

import CheckoutIntl from "@pages/Checkout/CheckoutIntl";
import CheckoutKr from "@pages/Checkout/CheckoutKr";

import { URLS } from "@const/urls";

import useLanguage from "@hooks/useLanguage";

import { useCartStore } from "@store/cart";
import { useLayoutStore } from "@store/layout";

export default function Checkout() {
  const navigate = useNavigate();

  const { lang } = useLanguage();

  const { cart } = useCartStore();
  const { showFooter } = useLayoutStore();

  useEffect(() => {
    showFooter(false);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (lang !== "jp") return;
    window.location.href = cart.checkoutUrl || URLS.HOME;
  }, [lang, cart.checkoutUrl]);

  if (lang === "jp") return null;

  return (
    <section className="pc:col-start-3 pc:w-full pc:min-w-160 pc:max-w-200 pc:place-self-center relative col-span-8 flex flex-col">
      <section className="pc:h-12.5 pc:min-h-12.5 pc:px-5 pc:p-4 flex h-13.5 min-h-13.5 items-center justify-between">
        <Link className="text-title font-features-normal leading-none" href={URLS.HOME}>
          thisisneverthat®
        </Link>
      </section>

      <section className="pc:p-5 pc:py-5 pc:gap-5 flex flex-col gap-4 py-12">
        <Button
          as="text"
          className="flex items-center gap-2 text-base!"
          onClick={() => {
            const checkoutBackUrl = sessionStorage.getItem("checkoutBackUrl");
            if (checkoutBackUrl) navigate(checkoutBackUrl);
            else navigate(-1);

            sessionStorage.removeItem("checkoutBackUrl");
          }}
        >
          <Icon className="h-3" name="LeftArrow" />
          Back
        </Button>

        {lang === "ko" ? <CheckoutKr /> : <CheckoutIntl />}
      </section>
    </section>
  );
}
